export enum PurchaseTypeEnum {
  FirstPurchase = 'FirstPurchase',
  Purchase = 'purchase',
}

export enum ReferralShareButtonTypeEnum {
  Email = 'email',
  Sms = 'sms',
  Facebook = 'facebook',
  WhatsApp = 'whatsapp',
  Twitter = 'twitter',
}
export type PaymentMethod =
  | 'PayPal_saved'
  | 'Stripe_saved'
  | 'PayPal'
  | 'Stripe'

export enum EventTypeEnum {
  PageView = 'Pageview',
  Purchase = 'purchase',
  CRegStart = 'c.reg.start',
  PayoutRequest = 'c.payout.request',
  GenreAdded = 'genre_added',
  GenreRemoved = 'genre_removed',
  LanguagesAdded = 'languages.added',
  LogOut = 'logout',
  NcStart = 'nc.start',
  CreateCampaign = 'CreatedCampaign',
  TrackAdded = 'track.added',
  PhoneAdded = 'phone.number.added',
  RegisterFormFilling = 'filling.form',
  FirstCampaignDetails = 'fc.details',
  CreatedFirstCampaign = 'CreatedFirstCampaign',
  CreatedCampaign = 'created_campaign',
  CreateFirstCampaignStart = 'fc.start',
  Login = 'login',
  CampaignBudgetUpdateEvent = 'campaign.budget.update',
  ViewSignUpPopUp = 'view_sign_up_pop-up',
  RegistrationComplete = 'registration_complete',
  CampaignScheduleStart = 'campaign_schedule_start',
  CheckoutView = 'view_checkout_pop_up',
  ThresholdCouponOfferShown = 'threshold_coupon_offer_shown',
  ThresholdCouponOfferApplied = 'threshold_coupon_offer_applied',
  ThresholdCouponOfferDismissed = 'threshold_coupon_offer_dismissed',
  ThresholdCouponRaised = 'threshold_coupon_raised',
  ThresholdCouponUnlocked = 'threshold_coupon_unlocked',
  ThresholdCouponRemoved = 'threshold_coupon_removed',
  ReviewRequestSeen = 'review_request_seen',
  ReviewMade = 'review_made',
  TrackAddedToPlaylist = 'track_added_to_playlist',
  ReviewSkipped = 'review_skipped',
  CuratorRegistrationStart = 'curator_registration_start',
  CreatorRegistrationStart = 'creator_registration_start',
  PlaylistAdded = 'playlist_added',
  PayoutRequested = 'payout_requested',
  PaymentMethodChanged = 'payment_method_changed',
  CampaignBudgetReceived = 'campaign_budget_received',
  CheckoutConfirmedPayment = 'checkout_confirmed_payment',
  ReviewRequestSeenNotAvailable = 'c_review_request_seen_not_available',
  PaymentCompleted = 'payment_completed',
  PaymentCancelled = 'payment_cancelled',
  CreatorReviewAvailableSongs = 'creator_review_available_songs',
  CreatorAcceptedTrack = 'creator_accepted_track',
  CreatorCancelledTask = 'creator_cancelled_task',
  CreatorUploadedVideo = 'creator_uploaded_video',
  ArtistReviewedVideo = 'artist_reviewed_video',
  ArtistAcceptedVideo = 'artist_accepted_video',
  ArtistRejectedVideo = 'artist_rejected_video',
  GA_EVENT = 'ga_event',
  MsgLowReachReceived = 'msg_low_reach_received',
}

export enum EventNameEnum {
  AddedTrackPlay = 'added_track_play',
  ReviewTrackSpotifyClicked = 'review_track_spotify_clicked',
  TrackListenStarted = 'track_listen_started',
  ReviewTrackListened = 'review_track_listened',
  FeedTrackListened = 'feed_track_listened',
  SearchedTrackPlay = 'searched_track_play  ',
  SignupLoginToError = 'signup_error_to_login',
  SignupLoginError = 'signup_login_error',
  LoginForm = 'login_form',
  QuickLogin = 'quick_login',
  PhoneEntered = 'phone_entered',
  TrackAdded = 'track_added',
  GenreAdded = 'genre_added',
  GenreRemoved = 'genre_removed',
  GenrePopupOpened = 'genre_popup_opened',
  PopupGenreAdded = 'popup_genre_added',
  LanguagesAdded = 'languages.added',
  ViewSignUpPopUp = 'view_sign_up_pop-up',
  RegistrationComplete = 'registration_complete',
  CreatedFirstCampaign = 'CreatedFirstCampaign',
  CreatedCampaign = 'created_campaign',
  CampaignScheduleStart = 'campaign_schedule_start',
  CheckoutView = 'view_checkout_pop_up',
  ThresholdCouponOfferShown = 'threshold_coupon_offer_shown',
  ThresholdCouponOfferApplied = 'threshold_coupon_offer_applied',
  ThresholdCouponOfferDismissed = 'threshold_coupon_offer_dismissed',
  ThresholdCouponRaised = 'threshold_coupon_raised',
  ThresholdCouponUnlocked = 'threshold_coupon_unlocked',
  ThresholdCouponRemoved = 'threshold_coupon_removed',
  ReviewRequestSeen = 'review_request_seen',
  ReviewMade = 'review_made',
  TrackAddedToPlaylist = 'track_added_to_playlist',
  ReviewSkipped = 'review_skipped',
  CuratorRegistrationStart = 'curator_registration_start',
  CreatorRegistrationStart = 'creator_registration_start',
  PlaylistAdded = 'playlist_added',
  PayoutRequested = 'payout_requested',
  PaymentMethodChanged = 'payment_method_changed',
  CampaignBudgetReceived = 'campaign_budget_received',
  CampaignBudgetUpdateEvent = 'campaign_budget_update',
  CheckoutConfirmedPayment = 'checkout_confirmed_payment',
  ReviewRequestSeenNotAvailable = 'c_review_request_seen_not_available',
  PaymentCompleted = 'payment_completed',
  PaymentCancelled = 'payment_cancelled',
  CreatorReviewAvailableSongs = 'creator_review_available_songs',
  CreatorAcceptedTrack = 'creator_accepted_track',
  CreatorCancelledTask = 'creator_cancelled_task',
  CreatorUploadedVideo = 'creator_uploaded_video',
  ArtistReviewedVideo = 'artist_reviewed_video',
  ArtistAcceptedVideo = 'artist_accepted_video',
  ArtistRejectedVideo = 'artist_rejected_video',
  ToggleActivated = 'toggle_activated',
  CuratorSelectedPositionAddTrack = 'curator_selected_position_add_track',
  ChangedLanguageOptions = 'changed_language_options',
  ClickShareReview = 'click_share_review',
  ViewShareReviewPopUp = 'view_share_review_pop_up',
  ClickDownloadImage = 'click_download_image',
  SearchUnavailable = 'search_unavaliable',
  StartedEnterTrack = 'started_enter_track',
  EnteredTrackUrl = 'entered_track_url',
  ErrorAddTrack = 'error_add_track',
  SoundLinkClick = 'soundlink_click',
  RelaunchDetailsClick = 'relaunch_details_click',
  RelaunchCampaignListClick = 'relaunch_campaign_list_click',
  CopyInviteLink = 'copy_invite_link',
  CopyInvitationMessage = 'copy_invitation_message',
  ErrorAccessToken = 'error_access_token',
  ErrorSameTrack = 'error_same_track',
  ErrorOfficialTrack = 'error_official_link',
  SubscriptionSelected = 'subscription_selected',
  ChangedPlan = 'changed_plan',
  SubscriptionConfirmedPayment = 'subscription_confirmed_payment',
  SubscriptionPaymentCompleted = 'subscription_payment_completed',
  ReferralShare = 'referral_share',
  ThankPageCreateTiktokCampaign = 'thank_page_create_tiktok_campaign',
  DiscoverTiktokPromotion = 'discover_tiktok_promotion',
  EnterTrack = 'enter_track',
  UpsellClick = 'upsell_click',
  NotificationClick = 'notification_click',
  TiktokAddTrackHint = 'tiktok_add_track_hint',
  MsgLowReachReceived = 'msg_low_reach_received',
  FAQTiktokCreating = 'faq_tiktok_creating',
  FAQTiktokCreatingAnotherQuestion = 'tiktok_creating_another_question',
  LaunchCampaignNotification = 'launch_campaign_notification',
  NewReleasedPromote = 'new_released_promote',
  NewReleasedCampaignsList = 'new_released_campaigns_list',
  CampaignDetailsViewed = 'campaign_details_viewed',
  GetBonusHeaderClicked = 'get_bonus_header_clicked',
  CreatorVisitSoundsInfo = 'creator_visit_sounds_info',
  SoundPopupOpened = 'sound_popup_opened',
  PlayerPressed = 'player_pressed',
  CreatorRegStart = 'creator_reg_start',
  CreatorRegAuthorizationStarted = 'creator_reg_authorization_started',
  CreatorRegAuthorizationFailed = 'creator_reg_authorization_failed',
  CreatorRegAuthorizationSuccess = 'creator_reg_authorization_success',
  CreatorRegAuthorizationProceed = 'creator_reg_authorization_proceed',
  CreatorRegEmailConfirmationRequested = 'creator_reg_email_confirmation_requested',
  CreatorSavedMinReward = 'creator_saved_min_reward',
}
